import { jsxs as g, jsx as o, Fragment as w } from "react/jsx-runtime";
import { forwardRef as I, useState as x, useRef as b, useEffect as s, useCallback as A } from "react";
import { u as l } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { Input as N } from "antd";
import { convertNumberToString as h, convertStringToNumber as T, IconContainer as y } from "@biron-data/react-components";
import { F as L } from "../../../../ExclamationIcon-ChUMLDqI.js";
import { L as c, N as R } from "../../../../dummyModel-DGc8qBEQ.js";
import { v as V, d as j, E as k } from "../../../../utils-Mz58x57M.js";
import z from "./SuffixPrefixWrapper.js";
import { useLanguageResolver as G } from "@biron-data/react-contexts";
import { s as $ } from "../../../../useForwardFocusOnInput-p4vGEjFi.js";
import "../../../../useResizeDetector-sfyDtky2.js";
const _ = I(({
  filter: t,
  temporaryFilter: e,
  handleTemporaryFilterChange: p,
  onFocus: C,
  onBlur: u
}, E) => {
  const d = G(), [a, f] = x(V(e, e.predicate.value.value)), [n, m] = x(h(a)), r = j(n), v = b();
  $(E, v), s(() => {
    r && m(h(V(e, t.predicate.value.value)));
  }, [t]), s(() => {
    f(r ? T(n) : void 0);
  }, [r, n]), s(() => {
    const i = k(e, a);
    e.predicate.value.value !== i && p({
      ...e,
      predicate: {
        ...e.predicate,
        value: {
          ...e.predicate.value,
          "@type": c.SCALAR,
          value: i
        }
      },
      isValid: r
    });
  }, [a, p, r, e]);
  const S = A((i) => {
    m(i.target.value);
  }, []);
  return /* @__PURE__ */ g("div", { children: [
    /* @__PURE__ */ o(K, { children: /* @__PURE__ */ o(
      z,
      {
        suffix: t.type === c.metric ? t.reference.suffix : void 0,
        prefix: t.type === c.metric ? t.reference.prefix : void 0,
        children: /* @__PURE__ */ o(
          P,
          {
            ref: v,
            value: n,
            status: r ? void 0 : "error",
            placeholder: d.get(`filter.type.${R.GREATER}.placeholder`),
            onChange: S,
            onFocus: C,
            onBlur: () => u(),
            onKeyDown: (i) => {
              i.keyCode === 13 && u();
            }
          }
        )
      }
    ) }),
    r ? /* @__PURE__ */ o(w, {}) : /* @__PURE__ */ g(D, { children: [
      /* @__PURE__ */ o(
        y,
        {
          size: 12,
          children: /* @__PURE__ */ o(L, {})
        }
      ),
      /* @__PURE__ */ o("span", { children: d.get(`filter.type.${R.GREATER}.warning`) })
    ] })
  ] });
}), D = l.div`
  display: flex;
  color: var(--target-red);
  font-size: 10px;
  align-content: center;
  align-items: center;
  gap: 4px;
`, K = l.div`
  display: flex;
  gap: 6px;
`, P = l(N)`
  line-height: 28px;
  padding: 0 6px;
  box-shadow: none !important;
`;
export {
  _ as default
};
//# sourceMappingURL=FilterScalar.js.map
